import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { NetworkSelectData } from "@modules/+new/payments/features/crypto-deposit/domain/entities/network-select-data";
import { Network } from "@modules/+new/payments/features/crypto-deposit/domain/entities/network.model";
import { TranslationService } from "@core-services/translation.service";

@Component({
	selector: "network-list",
	templateUrl: "./network-list.component.html",
	styleUrls: ["./network-list.component.scss"],
	standalone: false
})
export class NetworkListComponent implements OnInit {
	@Input() availableNetworks: Network[] = [];
	@Input() unavailableNetworks: Network[] = [];
	@Input() selectedCryptocoin = null;
	@Output() onSelectNetwork = new EventEmitter<NetworkSelectData>();
	public networkDisclaimer: string = "";

	constructor(private readonly translationService: TranslationService) {}

	ngOnInit(): void {
		this.networkDisclaimer = this.fetchTranslationsForNetworkDisclaimer();
	}

	public selectNetwork(networkId: string, networkName: string): void {
		this.onSelectNetwork.emit({
			selectedNetworkId: networkId,
			selectedNetworkName: networkName,
			cryptocoin: this.selectedCryptocoin
		});
	}

	public tooltipActionButtonClicked(url: string): void {
		window.open(url, "_blank");
	}

	private fetchTranslationsForNetworkDisclaimer(): string {
		const translation = this.translationService.translate("disclaimer_withdrawal_polygon");
		return translation !== "disclaimer_withdrawal_polygon" ? translation : "";
	}
}
